import { useEffect } from 'react';
import { gsap } from 'gsap';

export function useShopAnimation(cardsRef, styles) {
  useEffect(() => {
    const cards = cardsRef.current.filter(Boolean);
    const winsize = { width: window.innerWidth, height: window.innerHeight };
    const ctx = gsap.context(()=>{
    const timeline = gsap.timeline();

    // Set z-index for stacking
    cards.forEach((card, index) => {
      gsap.set(card, { zIndex: index + 1 });
    });

    // Phase 1: Start with single card in center
    const centerX = winsize.width / 2;
    const centerY = winsize.height / 2;

    cards.forEach((card, index) => {
      const rect = card.getBoundingClientRect();
      gsap.set(card, {
        x: centerX - rect.left - rect.width / 2,
        y: centerY - rect.top - rect.height / 2,
        scale: 0.6,
        rotation: gsap.utils.random(-10, 10),
        opacity: index === 0 ? 1 : 0
      });
    });

    // Phase 2: Stack cards one by one
    cards.slice(1).forEach((card, index) => {
      timeline.to(card, {
        duration: 0.2,
        opacity: 1,
        ease: 'power2.out',
        delay: index * 0.08
      });
    });

    // Phase 3: Throw to final positions
    timeline
      .addLabel('throwCards', '+=0.3')
      .to(cards, {
        duration: 0.8,
        ease: 'expo',
        x: 0,
        y: 0,
        scale: 1,
        rotation: 0,
        stagger: 0.06
      }, 'throwCards')
      .fromTo("#navbar", 
        { autoAlpha: 0, y: -100 },
        { autoAlpha: 1, ease: 'sin.in', y: 0 }, 
        'throwCards'
      )
      .fromTo("." + styles.topBar, 
        { autoAlpha: 0 }, 
        { autoAlpha: 1 }, 
        "throwCards"
      ) 
      
      .fromTo("." + styles.heroBanner, 
        { autoAlpha: 0 }, 
        { autoAlpha: 1, duration: 1.5 }, 
        "throwCards"
      );
})
    return () => {
      ctx.revert();
    };
  }, [cardsRef, styles]);
}
